"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldControl = exports.FieldLabel = exports.Field = void 0;
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const Field_styles_1 = require("./Field.styles");
const FieldContext_1 = require("./FieldContext");
const Field = react_1.default.forwardRef((_a, forwardedRef) => {
    var { name } = _a, props = __rest(_a, ["name"]);
    // use `useId` when upgrading to React 18
    const [id, setId] = react_1.default.useState(`field-${(0, uuid_1.v4)()}`);
    const [describedByIds, setDescribedByIds] = react_1.default.useState([]);
    const describedById = describedByIds.join(" ");
    const addDescribedById = react_1.default.useCallback((describeId) => {
        setDescribedByIds((prevIds) => [...prevIds, describeId]);
    }, []);
    const removeDescribedById = react_1.default.useCallback((describeId) => {
        setDescribedByIds((prevIds) => prevIds.filter((d) => d !== describeId));
    }, []);
    return (react_1.default.createElement(FieldContext_1.FieldContext.Provider, { value: {
            id: id,
            setId,
            name,
            addDescribedById,
            removeDescribedById,
            describedById,
        } },
        react_1.default.createElement(Field_styles_1.StyledField, Object.assign({}, props, { ref: forwardedRef, "data-field-name": name }))));
});
exports.Field = Field;
const FieldLabel = react_1.default.forwardRef((props, forwardedRef) => {
    const fieldContext = react_1.default.useContext(FieldContext_1.FieldContext);
    const htmlFor = props.htmlFor || (fieldContext === null || fieldContext === void 0 ? void 0 : fieldContext.id);
    return (react_1.default.createElement(Field_styles_1.StyledFieldLabel, Object.assign({}, props, { ref: forwardedRef, htmlFor: htmlFor })));
});
exports.FieldLabel = FieldLabel;
const FieldControl = ({ children }) => {
    const fieldContext = react_1.default.useContext(FieldContext_1.FieldContext);
    if (!fieldContext) {
        throw new Error("Form.Control must be used within a Field component");
    }
    if (!react_1.default.isValidElement(children) || react_1.default.Children.count(children) > 1) {
        throw new Error("Form.Control must have a single child form element component");
    }
    (0, react_1.useEffect)(() => {
        const props = children.props;
        if (props === null || props === void 0 ? void 0 : props.id) {
            fieldContext.setId(props.id);
        }
    }, [children, fieldContext.setId]);
    return react_1.default.cloneElement(children, Object.assign(Object.assign(Object.assign({}, children.props), { id: fieldContext.id, name: fieldContext.name }), (fieldContext.describedById && {
        "aria-describedby": fieldContext.describedById,
    })));
};
exports.FieldControl = FieldControl;
Field.displayName = "Field";
FieldLabel.displayName = "Field.Label";
FieldControl.displayName = "Field.Control";
//# sourceMappingURL=Field.js.map